<div class="col-sm-12 detail" *ngIf="!isEmpty" style="height: 100%" (click)="common.outSide($event)">
  <div class="header col-sm-12">
    <div class="col-sm-8">
      <h2> Liste des documents du client : {{ detail.nomClient || '' }} </h2>
    </div>
    <div class="col-sm-4 text-right">
      <button class="btn-header uppercase" id="close" (click)="hide()"> Fermer </button>
      <button class="btn-header uppercase actionPricipal" id="valide" [disabled]="disableBtn" (click)="valide()">
        Valider </button>
      <!--div>
          <label class="text-left uppercase text-underline historique" (click)="common.getLogs(detail.id, '43', modalService);"> Voir l'historique </label>
          <label class="text-left uppercase text-underline historique">Voir les documents</label>
        </div-->
    </div>
  </div>

  <div class="col-sm-12 ligneBon liste">
    <ngx-datatable style="height: 100%" class="material document" [rows]="listDocument || []" [columnMode]="'force'"
      [headerHeight]="30" [footerHeight]="0" [rowHeight]="40" [selectionType]="'checkbox'"
      [messages]="{emptyMessage: 'Pas de lignes à afficher'}" [loadingIndicator]="loadingIndicator"
      (activate)="onActivate($event)">
      <ngx-datatable-column name="Description">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Description </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div *ngIf="row.id && !row.edit">
            {{value}}
          </div>
          <div *ngIf="!row.id || row.edit">
            <input type="text" class="form-control" [(ngModel)]="row.description">
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="NomFichier" prop="nomFichier">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Fichier </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div *ngIf="row.id && !row.edit">
            {{value}}
          </div>
          <div *ngIf="!row.id || row.edit">
            <input class="hide" id="input-file-id{{rowIndex}}" (change)="getNameFile($event, row)" multiple
              type="file" accept="{{ common.extFichierImgEtTexte }}" />
            <div class="input-group">
              <input type="text" class="form-control" [(ngModel)]="row.nomFichier" readonly>
              <label class="input-group-addon" for="input-file-id{{rowIndex}}"><i class="fa fa-upload"></i> Parcourir
              </label>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column name="typeDocClient" prop="oTypeDocClient.libelle">
        <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
          let-sort="sortFn">
          <div class="tableheader" (click)="sort()">
            <span class="uppercase"> Type de document </span>
            <div class=" col-sm-1 pull-right">
              <i class=" col-sm-12 fa fa-angle-up" aria-hidden="true"></i>
              <i class=" col-sm-12 fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </div>
        </ng-template>
        <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
          <div *ngIf="row.id && !row.edit">
            {{ value || 'Aucun' }}
          </div>
          <div *ngIf="!row.id || row.edit">
            <app-autocomplete (selectfunction)="row.oTypeDocClient = $event;" [container]="true"
              [results]="typeDocuments" [highlight]="true" [isCombo]="true" id="typeDocuments"
              [dropdownclass]="'dropdownDocType'" [defaultselected]="row.oTypeDocClient"
              [defaultsearch]="row.oTypeDocClient ? row.oTypeDocClient.libelle : ''"></app-autocomplete>
          </div>
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column *ngIf="!common.isHisto" [width]="70" [sortable]="false" [canAutoResize]="false"
        [draggable]="false" [resizeable]="false">
        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
          <button class="btn-detail" *ngIf="row.id && !row.edit" (click)="editLigne(row)">
            <i class="fa fa-pencil"></i>
          </button>
          <button class="btn-detail" *ngIf="!row.edit" (click)="deleteLigne(row)">
            <i class="fa fa-trash"></i>
          </button>

          <button *ngIf="row.edit" class="btn-detail save" (click)="saveEdit(row)">
              <i class="fa fa-check" aria-hidden="true"></i>
            </button>

            <button *ngIf="row.edit" class="btn-detail cancel" (click)="cancel(row)">
              <i class="fa fa-times" aria-hidden="true"></i>
            </button>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
  <div class="addLigne col-sm-12 uppercase">
    <div class="col-sm-7 text-left">
      <button class="btn-add" id="addLigne" (click)="addLigne()">
        <i class="fa fa-plus"></i>
      </button>
      <span (click)="addLigne()">Ajouter une ligne</span>
    </div>
    <label class="text-left uppercase text-underline historique col-sm-5"></label>
  </div>
</div>

<app-empty-detail-fact *ngIf="isEmpty" id="empty"></app-empty-detail-fact>
<ng-template #msg>
  <div class="modal-body" style="height: auto">
    <div>
      <div class="col-sm-12">
        <label class="cofirmemsg" [innerHTML]="error"> </label>
      </div>
    </div>
    <div class="text-right" style="margin-top: 15px;">
      <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer
      </button>
    </div>
  </div>
</ng-template>